<template>
	<div class="main">
	   没做
	</div>
</template>

<script>
export default{
	name:'Article',
	data(){
		return {
			
		}
	},
	methods:{
		
	},
	mounted() {
	}
}
</script>

<style>
</style>
